import type {ReactElement} from 'react';
import React from 'react';
import {getCurrentPageBackground} from '@Components/poster-editor/poster-editor-reducer';
import {BaseMultiplyColorPanel} from '@Components/poster-editor/components/poster-editing-side-panel/components/base-multiply-color-panel';
import type {RGBA} from '@Utils/color.util';
import {useAppSelector} from '@/hooks';
import {BackgroundTypeName} from '@PosterWhiteboard/page/background/background.types';

export function VideoBgMultiplyColorPanel(): ReactElement<any> | null {
  const currentPageBackground = useAppSelector(getCurrentPageBackground);
  const currentPage = window.posterEditor?.whiteboard?.getCurrentPage();

  if (!currentPageBackground) {
    return null;
  }

  if (currentPageBackground.details.type !== BackgroundTypeName.VIDEO) {
    return null;
  }

  const videoDetails = currentPageBackground.details;

  const onUpdateColor = (multiplyColor: RGBA, undoable = true): void => {
    void currentPage?.background.updateFromObject(
      {
        details: {
          effects: {
            multiplyColor,
          },
        },
      },
      {undoable}
    );
  };

  return <BaseMultiplyColorPanel multiplyColor={videoDetails.effects.multiplyColor} onUpdateMultiplyColor={onUpdateColor} />;
}
